import { useActiveTournament } from '../state/TournamentContext';
import { useActiveRole } from '../state/RoleContext';
import { useStore } from '../hooks/useStore';
import { getDb } from '../services/store';
import { ShieldCheck } from 'lucide-react';

/**
 * Captain "My Team" lens inside the public event view. Pulls the captain's
 * roster from `roleAssignments` and shows it inline so they can confirm the
 * team without leaving `/e/:slug`.
 */
export function EventMyTeamPage() {
  const { tournament, teams } = useActiveTournament();
  const { profile } = useActiveRole();
  useStore((d) => d);
  const db = getDb();

  const myCaptaincies = db.roleAssignments.filter(
    (a) => a.profileId === profile.id && a.tournamentId === tournament.id && a.role === 'captain' && a.teamId,
  );
  const myTeams = teams.filter((t) => myCaptaincies.some((a) => a.teamId === t.id));

  if (myTeams.length === 0) {
    return (
      <div className="card">
        <div className="empty">
          You aren't a captain in this tournament. Switch to a captain profile in the preview switcher to see this view.
        </div>
      </div>
    );
  }

  return (
    <>
      {myTeams.map((team) => {
        const roster = db.rosterEntries.filter((r) => r.teamId === team.id && r.tournamentId === tournament.id);
        const confirmed = roster.filter((r) => r.status === 'confirmed').length;
        return (
          <div className="card" key={team.id}>
            <div className="card__head">
              <div className="row" style={{ gap: 10, alignItems: 'center' }}>
                <div style={{ width: 8, height: 28, borderRadius: 999, background: team.primaryColor }} />
                <div>
                  <h3 className="card__title"><ShieldCheck size={16} style={{ verticalAlign: -2, marginRight: 6 }} /> {team.name}</h3>
                  <p className="card__sub">{team.shortCode} · {confirmed}/{roster.length} confirmed</p>
                </div>
              </div>
            </div>
            {roster.length === 0 ? (
              <div className="empty">No players yet — an admin adds the roster.</div>
            ) : (
              <table className="table">
                <thead><tr><th>#</th><th>Player</th><th>Status</th></tr></thead>
                <tbody>
                  {roster.map((r) => {
                    const player = db.players.find((p) => p.id === r.playerId);
                    const profile = player ? db.profiles.find((p) => p.id === player.profileId) : null;
                    return (
                      <tr key={r.id}>
                        <td className="muted">{r.jerseyNumber ?? '—'}</td>
                        <td style={{ fontWeight: 600 }}>{profile?.displayName ?? 'Unknown'}</td>
                        <td>
                          <span className={`chip chip--${r.status === 'confirmed' ? 'ok' : 'warn'}`}>
                            <span className="chip__dot" />
                            {r.status}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        );
      })}
    </>
  );
}
